import { MARKETPLACE } from "../../../data/page_types"

export default () => window.location.pathname.toLowerCase().includes(`/${MARKETPLACE}`)
  || window.location.host === `${MARKETPLACE}.ulsemo.com`
  || window.location.host === `${MARKETPLACE}.ulsemo.cz`
  || window.location.host === `ulsemo.store`
  || window.location.host === `${MARKETPLACE}.ulsemo.localhost:8082`
  